import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-iniciar-sesion',
  templateUrl: './iniciar-sesion.component.html',
  styleUrls: ['./iniciar-sesion.component.scss']
})
export class IniciarSesionComponent implements OnInit {
  enviroment = environment.BASE_URL;
  input;
  public errorMsg:string;

  constructor(private router: Router, private _loginService : LoginService) { }

  ngOnInit(): void {
    this.input = {
      username: '',
      password: ''
    }
  }

  onLogin(){
    this.errorMsg = '';
    this._loginService.loginUser(this.input).subscribe(
      response => {
        this._loginService.guardarToken(response.token);
        // console.log('local storage \n' + localStorage.getItem('token')); 
        this.router.navigate(['perfil']);
        // this.router.navigate(['simulador']);
      },
      error =>{
        console.log('error: ', error)
        this.errorMsg = 'No hemos podido iniciar sesión con las credenciales proporcionadas';
      }
    )
  }

}
